export default __webpack_public_path__ + "static/media/red_gift_nutmeg.69e3428e.png";